
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st1",attrs:{"fill":"#FFF","cx":"22","cy":"22","r":"22"}}),_c('path',{attrs:{"fill":"#1877F2","d":"M44 22C44 9.9 34.1 0 22 0S0 9.9 0 22c0 10.8 7.8 20.1 18.6 21.8V28.4H13V22h5.6v-4.9c0-5.5 3.3-8.5 8.3-8.5 1.6 0 3.3.1 4.9.5v5.4H29c-1.7-.2-3.3 1-3.5 2.7V22h6.1l-1 6.4h-5.1v15.4C36.1 42.1 44 32.9 44 22z"}})])
          )
        }
      }
    